/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { CatalogService } from './services/catalog.service';
import { StateService } from './services/state.service';
import { AccountService } from './services/account.service';
import { Router } from '@angular/router';
import { CurrentUserModel } from './models/current-user.model';
import { SMSService } from './services/sms.service';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(
    public accountService: AccountService,
    private analytics: AnalyticsService,
    private seoService: SeoService,
    public stateService: StateService,
    public SMSService: SMSService,
    public catalogService: CatalogService,
    private router: Router
  ) {
  }



  ngOnInit(): void { 
    const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
    const token: string = String(localStorage.token);

    if (localStorage.currentUser && localStorage.token) { 
      
      this.accountService.validate(token, currentUser.email, currentUser.role_no,currentUser.clinic_no)
        .then((res: number) => {
          switch (res) {
            case 1:
              // this.router.navigate(["/pages/dashboard"])
              break;
            default:
              this.router.navigate(["/auth/login"])
              break;
          }
        });
    } else {
      this.router.navigate(["/auth/login"])
    }

    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    // this.catalogService.getCodesFile(true).then(() => { });
    // this.catalogService.getDoctors().then(() => { });
    // this.catalogService.getCategories().then(() => { });
    // this.catalogService.getGenericEstimates().then(() => { });
    // this.catalogService.getClientCode().then(() => { });
    // this.catalogService.getZip().then(() => { });
    // this.catalogService.getClientAuthority().then(() => { });
    // this.catalogService.getApptProc().then(() => { });
    // this.catalogService.getSpecie().then(() => { });
    // this.catalogService.getColor().then(() => { });
    // this.catalogService.getBreed().then(() => { });
    // this.catalogService.getPetCode().then(() => { });
    // this.catalogService.getBodyPart().then(() => { });
    // this.catalogService.getClinicDept().then(() => { });
    // this.catalogService.getDentalCode().then(() => { });
    // this.catalogService.getDentalProblem().then(() => { });
    // this.catalogService.getFoodType().then(() => { });
    // this.catalogService.getClinicCodes().then(() => { });
    // this.catalogService.getEmployees().then(() => { });
    // this.catalogService.getClinics().then(() => { });
    // this.catalogService.getVendors().then(() => { });
    // this.catalogService.getBaseCharge().then(() => { });
    // this.catalogService.getProcedureList().then(() => { });
    // this.catalogService.getInventoryList().then(() => { });
    // this.catalogService.getDrugAdminRoute().then(() => { });
    // this.catalogService.getCodesByVendor().then(() => { });
    // this.catalogService.getQuickNote().then(() => { });
    // this.catalogService.getNoteType().then(() => { });
    // this.catalogService.getDepartments().then(() => { });
    // this.catalogService.getDiagnosis().then(() => { });
    // this.catalogService.getPrompt().then(() => { });
    // this.catalogService.getPetNoteTypeList().then(() => { }); 
    // this.catalogService.getSutureCodes(currentUser.clinic_no).then(() => { });
  }
}
